import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '../Checkbox';
import PhoneLink from '../../Components/PhoneLink';
import SendEmailModal from '../../Components/Leads/SendEmailModal';
import helpers from "../../Utils/helpers";

function LeadsList({leads, hideCustomer, onLineSelect, selectedLeads, sortListByKey, activeLead, moveToDetails, styles}) {
    const { t } = useTranslation();

    const [showSendEmailModal, setShowSendEmailModal] = useState(false);
    const [emailActionLogId, setEmailActionLogId] = useState(0);
    const [modalLead, setModalLead] = useState(null);

    function renderNoData() {
        return (<p>{t('leadslist.noentriesfound')}</p>);
    }

    function onMoveToDetails(e, leadId) {
        if (
            e.target.className === "preventRowClick"
            || e.target.tagName === "INPUT"
            || e.target.tagName === "LABEL"
        ) {
            onLineSelect && onLineSelect(leadId);
        }
        if (e.target.className !== "preventRowClick") {
            moveToDetails && moveToDetails(leadId);
        }
    }

    function renderStyles() {
        if (!styles) return null;
        return styles;
    }

    function sortList() {
        const jsonSort = localStorage.getItem("sortOrder_myLeads");
        return jsonSort ? JSON.parse(jsonSort) : [];
    }

    function toggleModal(modalName, lead, actionLogId = 0) {
        if (modalName === 'showSendEmailModal') {
            setShowSendEmailModal(v => !v);
            setModalLead(lead);
            setEmailActionLogId(actionLogId);
        }
    }

    if (!leads || leads.length === 0) {
        return renderNoData();
    }

    let showCheckbox = leads.some(lead => !lead.isClosed) && onLineSelect;
    const sort = sortList();
    const sortOrder =
        sort.sortOrder === "asc"
            ? "pull-right vismaicon vismaicon-sm vismaicon-arrow-up-circle"
            : "pull-right vismaicon vismaicon-sm vismaicon-arrow-down-circle";
    const sortKey = sort.key;

    return (
        <div className="table-responsive" style={renderStyles()}>
            <table className="table table-stripe table-hover table-active">
                <thead>
                <tr>
                    {showCheckbox && <th className="text-center" width="30"></th>}
                    <th className="text-left sortable" onClick={() => sortListByKey('status')}>
                        {t('leadslist.status')} {sortKey === 'status' && <i className={sortOrder}></i>}
                    </th>
                    {!hideCustomer && (
                        <th className="text-left sortable" onClick={() => sortListByKey('submitted')}>
                            {t('leadslist.submitted')} {sortKey === 'submitted' && <i className={sortOrder}></i>}
                        </th>
                    )}
                    {!hideCustomer && (
                        <th className="text-left sortable" onClick={() => sortListByKey('customerNumber')}>
                            {t('leadslist.customernumber')} {sortKey === 'customerNumber' && <i className={sortOrder}></i>}
                        </th>
                    )}
                    {!hideCustomer && (
                        <th className="text-left sortable" onClick={() => sortListByKey('name')}>
                            {t('leadslist.name')} {sortKey === 'name' && <i className={sortOrder}></i>}
                        </th>
                    )}
                    <th className="text-left sortable" onClick={() => sortListByKey('contact')}>
                        {t('leadslist.contact')} {sortKey === 'contact' && <i className={sortOrder}></i>}
                    </th>
                    {!hideCustomer && (
                        <th className="text-left sortable" onClick={() => sortListByKey('email')}>
                            {t('leadslist.email')} {sortKey === 'email' && <i className={sortOrder}></i>}
                        </th>
                    )}
                    {!hideCustomer && (
                        <th className="text-left sortable" onClick={() => sortListByKey('phonenumber')}>
                            {t('leadslist.phonenumber')} {sortKey === 'phoneNumber' && <i className={sortOrder}></i>}
                        </th>
                    )}
                    <th className="text-left sortable" onClick={() => sortListByKey('productNumber')}>
                        {t('leadslist.type')} {sortKey === 'productNumber' && <i className={sortOrder}></i>}
                    </th>
                    <th className="text-left sortable" onClick={() => sortListByKey('lastActionDate')}>
                        {t('leadslist.lastaction')} {sortKey === 'lastActionDate' && <i className={sortOrder}></i>}
                    </th>
                </tr>
                </thead>
                <tbody>
                {leads.map((lead, index) => {
                    let classes = "cursorpointer";
                    let checked = false;

                    if (selectedLeads) {
                        let result = selectedLeads.find(item => item.id === lead.id);
                        if (result !== undefined && result.id === lead.id) {
                            classes = "cursorpointer active";
                            checked = true;
                        }
                    }

                    if (lead.isClosed) showCheckbox = false;
                    if (activeLead) classes = activeLead.id === lead.id ? classes + " active" : classes;

                    return (
                        <tr className={classes} key={index} onClick={e => onMoveToDetails(e, lead.id)}>
                            {showCheckbox && (
                                <td className="preventRowClick">
                                    <Checkbox checked={checked} onChange={() => onLineSelect(lead.id)} pure={true} />
                                </td>
                            )}
                            <td>{lead.status}</td>
                            {!hideCustomer && (
                                <td className="text-nowrap">{helpers.formatDateAndTime(lead.dateSubmitted)}</td>
                            )}
                            {!hideCustomer && <td>{lead.customerNumber ? lead.customerNumber : 'N/A'}</td>}
                            {!hideCustomer && <td>{lead.name}</td>}
                            <td>{lead.contact}</td>
                            {!hideCustomer && (
                                <td>
                                    {lead.email}
                                    <span
                                        onClick={e => {
                                            e.stopPropagation();
                                            toggleModal("showSendEmailModal", lead);
                                        }}
                                        className="pull-right vismaicon vismaicon-sm vismaicon-email"
                                    ></span>
                                </td>
                            )}
                            {!hideCustomer && (
                                <td>
                                    {lead.phoneNumber}
                                    {lead.phoneNumber && <PhoneLink phoneNumber={lead.phoneNumber} icon={true} />}
                                </td>
                            )}
                            <td>
                                {lead.productNumber ? `${lead.type}: ${lead.productNumber}` : lead.type}
                            </td>
                            <td>
                                {lead.lastAction === null ? '' : `${lead.lastAction} ${lead.lastActionDate}`}
                            </td>
                        </tr>
                    );
                })}
                {showSendEmailModal && (
                    <SendEmailModal
                        leadType="lead"
                        lead={modalLead}
                        emailActionLogId={emailActionLogId}
                    />
                )}
                </tbody>
            </table>
        </div>
    );
}

export default LeadsList;